document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(min-width: 990px)');

  const init = () => {
    if (!mq.matches) return;

    document.querySelectorAll('.header__inline-menu details').forEach((details) => {
      const submenu = details.querySelector('.header__submenu');
      if (!submenu) return;

      let t;

      const open = () => {
        clearTimeout(t);
        details.setAttribute('open', '');
      };

      const close = () => {
        t = setTimeout(() => details.removeAttribute('open'), 150);
      };

      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', close);

      // Tastatur: bei Fokus ebenfalls öffnen
      details.addEventListener('focusin', open);
      details.addEventListener('focusout', close);
    });
  };

  init();
  mq.addEventListener?.('change', init);
});
